var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2609 8.70437H6.73913C6.49901 8.70437 6.30435 8.89903 6.30435 9.13915V21.3131C6.30435 21.5532 6.49901 21.7479 6.73913 21.7479H23.2609C23.501 21.7479 23.6957 21.5532 23.6957 21.3131V9.13915C23.6957 8.89903 23.501 8.70437 23.2609 8.70437ZM6.73913 7.40002C5.77864 7.40002 5 8.17866 5 9.13915V21.3131C5 22.2736 5.77863 23.0522 6.73913 23.0522H23.2609C24.2214 23.0522 25 22.2736 25 21.3131V9.13915C25 8.17866 24.2214 7.40002 23.2609 7.40002H6.73913Z",
    fill: "#5F6272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4943 12.1731C13.2048 11.9889 12.8261 12.1968 12.8261 12.5399V17.9123C12.8261 18.2554 13.2048 18.4633 13.4943 18.2791L17.7155 15.5929C17.984 15.4221 17.984 15.0302 17.7155 14.8593L13.4943 12.1731Z",
    fill: "#5F6272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/Watch.ef7f5e5b4fe37760cfe4d9822e916380.svg";
export { ForwardRef as ReactComponent };